var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.service !== null)?_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-card-group',_vm._l((_vm.aantalUnitsPerOnderhoudscategorie),function(count,type,index){return _c('b-card',{key:index},[_c('div',{staticClass:"h4 m-0"},[_vm._v("\n        "+_vm._s(count)+"\n      ")]),_c('small',[_vm._v(_vm._s(type))])])}),1),_c('b-table',{attrs:{"fields":[
      'adres',
      'stopplaatsen',
      'advies',
      {
        key:'korsteDuurOnderhoud',
      },
      {
        key:'aantalOnderhoud',
      }
    ],"items":_vm.onderhoudOverzichtPerUnit.filter((u) => ['B'].includes(u.oh)),"small":"","bordered":""},scopedSlots:_vm._u([{key:"cell(advies)",fn:function(row){return [_vm._v("\n      "+_vm._s((Number(row.item.stopplaatsen) * Number(_vm.aantalonderhoud)).toFixed(1))+" beurten\n    ")]}},{key:"cell(korsteDuurOnderhoud)",fn:function(row){return [_vm._v("\n      "+_vm._s(row.item.korsteDuurOnderhoud)+"\n    ")]}},{key:"cell(aantalOnderhoud)",fn:function(row){return [_vm._v("\n      "+_vm._s(row.item.aantalOnderhoud)+"\n    ")]}}],null,false,4244831998)}),_c('b-table',{attrs:{"fields":[{
      key:'label',
      label: 'Titel',
    },{
      key: 'filters.category',
      label: 'Categorie',
    }]
      .concat(_vm.quarterFields).concat([{
        key:'gemiddelde',
        label:'Totaal'
      }]),"items":_vm.kpiService,"striped":"","hover":"","bordered":""},scopedSlots:_vm._u([{key:"cell(label)",fn:function(row){return [_vm._v("\n      "+_vm._s(row.item.label)+" "+_vm._s(row.item.total)+" units"),_c('br')]}},{key:"cell(quarters.kw0)",fn:function(row){return undefined}},{key:"cell(quarters.kw1)",fn:function(row){return undefined}},{key:"cell(quarters.kw2)",fn:function(row){return undefined}},{key:"cell(quarters.kw3)",fn:function(row){return undefined}}],null,false,1746879512)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }